export default {"src":"https://webcdn.trailways.com/_next/static/media/toggle-on.44d6a7ee.svg","height":44,"width":57,"blurWidth":0,"blurHeight":0};